var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ninja-grid create-method=\"addRole\" update-method=\"updateRole\" delete-method=\"removeRole\" add-toggle=\"vm.sideTab.roles\"></ninja-grid><div layout=\"row\" flex=\"flex\" layout-fill=\"layout-fill\" layout-padding=\"layout-padding\"><div flex=\"100\"><table class=\"table table-responsive\"><tbody>                    <tr ng-repeat=\"role in vm.docSvc.doc.roles track by $index\"><td>{{role}} </td><td style=\"padding: 4px\"></td><td style=\"padding: 4px\"><div flex=\"5\" layout=\"column\" layout-align=\"center center\" class=\"gridItemCell\"><a href=\"\" ng-click=\"vm.removeRoles($index)\" ng-blur=\"vm.detailBlur(role, $index, $event)\"><span class=\"glyphicon glyphicon-remove\"> </span></a></div></td></tr></tbody></table></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/administration/users/tabs/tab-roles.jade
// module id = 177
// module chunks = 0